import { NavigationButton as NavigationButtonType } from '@/schemas/sceneDataSchema';
import { RouteFn } from '@/hooks/use-flow';
import { ComponentButton } from './ComponentButton';

export const NavigationButton = ({ component, route }: { component: NavigationButtonType; route: RouteFn }) => {
  const onClick = () => {
    void route(component.entity_index, component.step_id);
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
    />
  );
};
